// we use object destrcuturing to remove props from the 'restProps' object that we forward to the SVG element -
// (e.g., { backgroundColor, ...restProps } if we don't want the 'backgroundColor' to propogate to the SVG element props),
// so without this supression typescript will complain about the unused variables:
/* eslint-disable @typescript-eslint/no-unused-vars */

export interface INavIconProps {
  backgroundColor: string;
  strokeColor: string;
  className: string;
}

export const HomeIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="-4 -3 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M4.68786 21.3542V11.7086L2.74281 13.2011L1.80322 11.9552L4.68786 9.7396V6.7508H6.25036V8.54169L12.5004 3.77606L23.1975 11.9552L22.2579 13.1852L20.3129 11.7086V21.3542H4.68786ZM6.25036 19.7917H11.2584V15.2242H13.7423V19.7917H18.7504V10.5209L12.5004 5.75523L6.25036 10.5209V19.7917Z"
      fill={strokeColor}
      stroke={strokeColor}
      strokeWidth="0.3"
    />
  </svg>
);

export const DashboardIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M13.4281 14.7719C14.6707 14.7719 15.6781 13.7646 15.6781 12.5219V10C15.6781 8.75736 14.6707 7.75 13.4281 7.75H11C9.75736 7.75 8.75 8.75736 8.75 10V12.5219C8.75 13.7646 9.75736 14.7719 11 14.7719H13.4281ZM11.3704 13.8925C10.4039 13.8925 9.62036 13.109 9.62036 12.1425V10.3758C9.62036 9.40927 10.4039 8.62577 11.3704 8.62577H13.054C14.0205 8.62577 14.804 9.40927 14.804 10.3758V12.1425C14.804 13.109 14.0205 13.8925 13.054 13.8925H11.3704Z"
      fill={strokeColor}
      stroke={strokeColor}
      strokeWidth="0.5"
    />
    <path
      d="M21.9998 14.7719C23.2425 14.7719 24.2498 13.7646 24.2498 12.5219V10C24.2498 8.75736 23.2425 7.75 21.9998 7.75H19.5718C18.3291 7.75 17.3218 8.75736 17.3218 10V12.5219C17.3218 13.7646 18.3291 14.7719 19.5718 14.7719H21.9998ZM19.9421 13.8925C18.9756 13.8925 18.1921 13.109 18.1921 12.1425V10.3758C18.1921 9.40927 18.9756 8.62577 19.9421 8.62577H21.6258C22.5923 8.62577 23.3758 9.40927 23.3758 10.3758V12.1425C23.3758 13.109 22.5923 13.8925 21.6258 13.8925H19.9421Z"
      fill={strokeColor}
      stroke={strokeColor}
      strokeWidth="0.5"
    />
    <path
      d="M13.4998 23.2719C14.7425 23.2719 15.7498 22.2646 15.7498 21.0219V18.5C15.7498 17.2574 14.7425 16.25 13.4998 16.25H11.0718C9.82911 16.25 8.82175 17.2574 8.82175 18.5V21.0219C8.82175 22.2646 9.82911 23.2719 11.0717 23.2719H13.4998ZM11.058 22.3962C10.595 22.3962 10.1663 22.1525 9.92944 21.7548C9.81122 21.5562 9.74745 21.3301 9.74458 21.099L9.71726 18.9012C9.70514 17.9263 10.4921 17.1295 11.4671 17.1295H13.1295C14.096 17.1295 14.8795 17.913 14.8795 18.8795V20.6462C14.8795 21.6127 14.096 22.3962 13.1295 22.3962H11.058Z"
      fill={strokeColor}
      stroke={strokeColor}
      strokeWidth="0.5"
    />
    <path
      d="M21.9998 23.25C23.2425 23.25 24.2498 22.2426 24.2498 21V18.478C24.2498 17.2354 23.2425 16.228 21.9998 16.228H19.5718C18.3291 16.228 17.3218 17.2354 17.3218 18.478V21C17.3218 22.2426 18.3291 23.25 19.5718 23.25H21.9998ZM21.6295 22.3742H19.9999H19.9421C18.9756 22.3742 18.1921 21.5907 18.1921 20.6242V18.8575C18.1921 17.891 18.9756 17.1075 19.9421 17.1075H21.6295C22.596 17.1075 23.3795 17.891 23.3795 18.8575V20.6242C23.3795 21.5907 22.596 22.3742 21.6295 22.3742Z"
      fill={strokeColor}
      stroke={strokeColor}
      strokeWidth="0.5"
    />
  </svg>
);

export const HistoryIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M8.5 26.1321C8.1 26.1321 7.75 25.9736 7.45 25.6566C7.15 25.3396 7 24.9698 7 24.5472V8.16981C7 7.74717 7.15 7.37736 7.45 7.06038C7.75 6.7434 8.1 6.58491 8.5 6.58491H10.125V5H11.75V6.58491H20.25V5H21.875V6.58491H23.5C23.9 6.58491 24.25 6.7434 24.55 7.06038C24.85 7.37736 25 7.74717 25 8.16981V24.5472C25 24.9698 24.85 25.3396 24.55 25.6566C24.25 25.9736 23.9 26.1321 23.5 26.1321H8.5ZM8.5 24.5472H23.5V13.1887H8.5V24.5472ZM8.5 11.6038H23.5V8.16981H8.5V11.6038ZM16 17.6792C15.7167 17.6792 15.4792 17.578 15.2875 17.3755C15.0958 17.173 15 16.922 15 16.6226C15 16.3233 15.0958 16.0723 15.2875 15.8698C15.4792 15.6673 15.7167 15.566 16 15.566C16.2833 15.566 16.5208 15.6673 16.7125 15.8698C16.9042 16.0723 17 16.3233 17 16.6226C17 16.922 16.9042 17.173 16.7125 17.3755C16.5208 17.578 16.2833 17.6792 16 17.6792ZM12 17.6792C11.7167 17.6792 11.4792 17.578 11.2875 17.3755C11.0958 17.173 11 16.922 11 16.6226C11 16.3233 11.0958 16.0723 11.2875 15.8698C11.4792 15.6673 11.7167 15.566 12 15.566C12.2833 15.566 12.5208 15.6673 12.7125 15.8698C12.9042 16.0723 13 16.3233 13 16.6226C13 16.922 12.9042 17.173 12.7125 17.3755C12.5208 17.578 12.2833 17.6792 12 17.6792ZM20 17.6792C19.7167 17.6792 19.4792 17.578 19.2875 17.3755C19.0958 17.173 19 16.922 19 16.6226C19 16.3233 19.0958 16.0723 19.2875 15.8698C19.4792 15.6673 19.7167 15.566 20 15.566C20.2833 15.566 20.5208 15.6673 20.7125 15.8698C20.9042 16.0723 21 16.3233 21 16.6226C21 16.922 20.9042 17.173 20.7125 17.3755C20.5208 17.578 20.2833 17.6792 20 17.6792ZM16 21.9057C15.7167 21.9057 15.4792 21.8044 15.2875 21.6019C15.0958 21.3994 15 21.1484 15 20.8491C15 20.5497 15.0958 20.2987 15.2875 20.0962C15.4792 19.8937 15.7167 19.7925 16 19.7925C16.2833 19.7925 16.5208 19.8937 16.7125 20.0962C16.9042 20.2987 17 20.5497 17 20.8491C17 21.1484 16.9042 21.3994 16.7125 21.6019C16.5208 21.8044 16.2833 21.9057 16 21.9057ZM12 21.9057C11.7167 21.9057 11.4792 21.8044 11.2875 21.6019C11.0958 21.3994 11 21.1484 11 20.8491C11 20.5497 11.0958 20.2987 11.2875 20.0962C11.4792 19.8937 11.7167 19.7925 12 19.7925C12.2833 19.7925 12.5208 19.8937 12.7125 20.0962C12.9042 20.2987 13 20.5497 13 20.8491C13 21.1484 12.9042 21.3994 12.7125 21.6019C12.5208 21.8044 12.2833 21.9057 12 21.9057ZM20 21.9057C19.7167 21.9057 19.4792 21.8044 19.2875 21.6019C19.0958 21.3994 19 21.1484 19 20.8491C19 20.5497 19.0958 20.2987 19.2875 20.0962C19.4792 19.8937 19.7167 19.7925 20 19.7925C20.2833 19.7925 20.5208 19.8937 20.7125 20.0962C20.9042 20.2987 21 20.5497 21 20.8491C21 21.1484 20.9042 21.3994 20.7125 21.6019C20.5208 21.8044 20.2833 21.9057 20 21.9057Z"
      fill={strokeColor}
    />
  </svg>
);

export const IssuesIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="-8 -8 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M0.747059 17C0.747059 25.9618 8.03691 33.2529 16.9974 33.2529C25.963 33.2529 33.2529 25.9619 33.2529 17C33.2529 8.03805 25.9578 0.747059 16.9974 0.747059C8.03691 0.747059 0.747059 8.03816 0.747059 17ZM2.55779 17C2.55779 9.03786 9.03665 2.558 16.9974 2.558C24.9634 2.558 31.4422 9.03792 31.4422 17C31.4422 24.962 24.9582 31.442 16.9974 31.442C9.03665 31.442 2.55779 24.9621 2.55779 17Z"
      fill={strokeColor}
      stroke={strokeColor}
      strokeWidth="0.505882"
    />
    <path
      d="M15.486 20.2769L15.1107 9.81939H18.4575L18.0821 20.2769H15.486ZM16.7789 21.8617C17.1264 21.8617 17.4322 21.9347 17.6964 22.0807C17.9675 22.2266 18.176 22.4247 18.3219 22.6749C18.4679 22.9252 18.5409 23.2067 18.5409 23.5195C18.5409 23.8323 18.4679 24.1138 18.3219 24.364C18.176 24.6142 17.9675 24.8123 17.6964 24.9583C17.4322 25.1043 17.1264 25.1772 16.7789 25.1772C16.4313 25.1772 16.1255 25.1043 15.8614 24.9583C15.5972 24.8123 15.3922 24.6142 15.2462 24.364C15.1002 24.1138 15.0273 23.8323 15.0273 23.5195C15.0273 23.2067 15.1002 22.9252 15.2462 22.6749C15.3922 22.4247 15.5972 22.2266 15.8614 22.0807C16.1255 21.9347 16.4313 21.8617 16.7789 21.8617Z"
      fill={strokeColor}
    />
  </svg>
);

export const LossesIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="-7 -8 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M0.2 18C0.0895431 18 0 17.9105 0 17.8V16.0828C0 16.0298 0.0210714 15.9789 0.0585786 15.9414L1.65858 14.3414C1.78457 14.2154 2 14.3047 2 14.4828V17.8C2 17.9105 1.91046 18 1.8 18H0.2ZM4.2 18C4.08954 18 4 17.9105 4 17.8V12.0828C4 12.0298 4.02107 11.9789 4.05858 11.9414L5.65858 10.3414C5.78457 10.2154 6 10.3047 6 10.4828V17.8C6 17.9105 5.91046 18 5.8 18H4.2ZM8.2 18C8.08954 18 8 17.9105 8 17.8V10.4871C8 10.3083 8.21667 10.2194 8.3423 10.3466L9.9423 11.9666C9.97927 12.004 10 12.0545 10 12.1071V17.8C10 17.9105 9.91046 18 9.8 18H8.2ZM12.2 18C12.0895 18 12 17.9105 12 17.8V12.1078C12 12.0548 12.0211 12.0039 12.0586 11.9664L13.6586 10.3664C13.7846 10.2404 14 10.3297 14 10.5078V17.8C14 17.9105 13.9105 18 13.8 18H12.2ZM16.2 18C16.0895 18 16 17.9105 16 17.8V8.08284C16 8.0298 16.0211 7.97893 16.0586 7.94142L17.6586 6.34142C17.7846 6.21543 18 6.30466 18 6.48284V17.8C18 17.9105 17.9105 18 17.8 18H16.2ZM0.341421 12.4836C0.215428 12.6096 0 12.5203 0 12.3422V10.0828C0 10.0298 0.0210714 9.97893 0.0585786 9.94142L6.85858 3.14142C6.93668 3.06332 7.06332 3.06332 7.14142 3.14142L10.8586 6.85858C10.9367 6.93668 11.0633 6.93668 11.1414 6.85858L17.6586 0.341421C17.7846 0.215428 18 0.304662 18 0.482843V2.74216C18 2.7952 17.9789 2.84607 17.9414 2.88358L11.1414 9.68358C11.0633 9.76168 10.9367 9.76168 10.8586 9.68358L7.14142 5.96642C7.06332 5.88832 6.93668 5.88832 6.85858 5.96642L0.341421 12.4836Z"
      fill={strokeColor}
    />
  </svg>
);

export const PermissionsIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="17 10 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M34 27C36.21 27 38 25.21 38 23C38 20.79 36.21 19 34 19C31.79 19 30 20.79 30 23C30 25.21 31.79 27 34 27ZM34 29C31.33 29 26 30.34 26 33V35H42V33C42 30.34 36.67 29 34 29Z"
      fill={strokeColor}
    />
  </svg>
);

export const ActivityLogIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="4 4 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M14.7927 16.7981C14.6781 16.6878 14.33 16.3488 14.6675 14.5844C14.7418 14.2005 15.0114 12.916 15.4189 12.528L19.6279 8.5255C20.2243 7.95779 21.1901 7.96391 21.7802 8.53775L23.457 10.1694C24.047 10.7432 24.0407 11.6724 23.4442 12.2401L19.2352 16.2447C18.8277 16.6327 17.4905 16.8777 17.0893 16.9451C15.2533 17.2494 14.9052 16.9104 14.7906 16.8001L14.7927 16.7981ZM21.1349 9.15038C20.8972 8.91758 20.5066 8.91554 20.2647 9.1463L16.0557 13.1509C15.7054 13.5511 15.3361 15.6851 15.4507 16.1712C15.9559 16.2876 18.1761 15.9567 18.6027 15.6198L22.8053 11.6213C23.0473 11.3926 23.0494 11.0169 22.8096 10.7841L21.1328 9.15242L21.1349 9.15038Z"
      fill={strokeColor}
    />
    <path
      d="M15.8135 17.1696C15.0239 17.1696 14.8138 16.9634 14.7162 16.8694C14.5782 16.7367 14.2153 16.3814 14.5612 14.5659C14.6568 14.0636 14.9263 12.8526 15.3423 12.4564L19.5513 8.45184C20.1902 7.84533 21.2239 7.84941 21.8543 8.46409L23.5311 10.0957C23.8368 10.3939 24.0023 10.788 24.0002 11.2067C23.9981 11.6253 23.8261 12.0174 23.5184 12.3114L19.3094 16.316C18.8912 16.7122 17.6304 16.9572 17.1083 17.043C16.5585 17.1349 16.1362 17.1676 15.8135 17.1676V17.1696ZM20.6975 8.20474C20.3367 8.20474 19.978 8.33544 19.702 8.59683L15.493 12.6014C15.1874 12.8914 14.9199 13.8267 14.7714 14.6027C14.5549 15.7381 14.5867 16.4528 14.869 16.7265C15.1492 17.0001 15.8921 17.0389 17.0743 16.8429C17.883 16.7081 18.8573 16.4631 19.1629 16.171L23.3719 12.1664C23.6415 11.9112 23.7901 11.5701 23.7922 11.2046C23.7943 10.8391 23.65 10.498 23.3846 10.2387L21.7078 8.60704C21.4319 8.33748 21.0668 8.2027 20.6996 8.2027L20.6975 8.20474ZM15.4697 16.3262C15.423 16.3262 15.3827 16.2956 15.3678 16.2548H15.3614L15.3466 16.1915C15.232 15.7116 15.5907 13.5204 15.9727 13.0813L20.1902 9.07264C20.3282 8.94195 20.5065 8.8623 20.7018 8.87251C20.8949 8.87251 21.0753 8.94603 21.2112 9.07877L22.888 10.7104C23.1681 10.982 23.1639 11.4231 22.8816 11.6927L18.679 15.6911C18.229 16.0485 16.2359 16.3467 15.5546 16.2874C15.5355 16.3119 15.5058 16.3262 15.4718 16.3262H15.4697ZM15.544 16.0832C16.1383 16.1567 18.1696 15.83 18.5368 15.54L22.733 11.5477C22.9325 11.3578 22.9347 11.0474 22.7373 10.8554L21.0605 9.22376C20.9649 9.12982 20.8376 9.07877 20.7018 9.07877C20.5744 9.07877 20.4364 9.12778 20.3409 9.21967L16.1319 13.2222C15.8348 13.5633 15.4739 15.5114 15.544 16.0832Z"
      fill={strokeColor}
    />
    <path
      d="M19.1187 9.62379L18.4741 10.2368L21.372 13.0572L22.0165 12.4441L19.1187 9.62379Z"
      fill={strokeColor}
    />
    <path
      d="M21.3701 13.1998L18.3242 10.2347L19.1202 9.47705L22.166 12.4422L21.3701 13.1998ZM18.6235 10.2367L21.3722 12.9119L21.8667 12.4422L19.118 9.76703L18.6235 10.2367Z"
      fill={strokeColor}
    />
    <path
      d="M22.3954 14.7641V20.629C22.3954 21.2988 21.8308 21.842 21.1346 21.842H11.4643C10.7681 21.842 10.2014 21.2988 10.2014 20.627V11.3272C10.2014 10.6574 10.766 10.1142 11.4622 10.1142H16.3589C16.6051 10.1142 16.8046 9.92222 16.8046 9.68534V9.38515C16.8046 9.14826 16.6051 8.9563 16.3589 8.9563H11.4643C10.1037 8.95426 9 10.0162 9 11.3272V20.629C9 21.938 10.1037 22.9999 11.4643 22.9999H21.1325C22.493 22.9999 23.5967 21.938 23.5967 20.629V14.7641C23.5967 14.5272 23.3972 14.3352 23.151 14.3352H22.839C22.5928 14.3352 22.3932 14.5272 22.3932 14.7641H22.3954Z"
      fill={strokeColor}
    />
  </svg>
);

export const TrackersIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <g clipPath="url(#clip0_2661_7718)">
      <path
        d="M26.1372 21.8368L23.6688 15.6715C23.5619 15.4064 23.2995 15.2395 23.008 15.2395H8.18759C7.89605 15.2395 7.63365 15.4064 7.52675 15.6715L5 21.9742H5.01944C4.99028 22.1509 5.03887 22.3374 5.14577 22.4847C5.28183 22.6614 5.49563 22.7694 5.71915 22.7694H13.4257V24.6838H10.0535C9.63562 24.6838 9.3052 25.0176 9.3052 25.4397C9.3052 25.8619 9.64534 26.1957 10.0535 26.1957H21.0546C21.4725 26.1957 21.8029 25.8619 21.8029 25.4397C21.8029 25.0176 21.4628 24.6838 21.0546 24.6838H17.6824V22.7694H25.4861C25.7096 22.7694 25.9234 22.6614 26.0595 22.4847C26.1956 22.2982 26.2344 22.0527 26.147 21.8368H26.1372ZM10.5686 19.6868L10.1118 21.4048H6.73957L7.42957 19.6868H10.5686ZM11.4238 16.6041L10.9379 18.3221H7.98351L8.67351 16.6041H11.4238ZM16.3024 18.3221V16.6041H18.4695L18.8194 18.3221H16.2926H16.3024ZM14.8932 19.6868V21.4048H11.5696L12.0263 19.6868H14.8932ZM14.9321 22.7694H16.176V24.6838H14.9321V22.7694ZM19.6357 21.4048H16.3121V19.6868H19.179L19.6357 21.4048ZM12.4053 18.3221L12.8912 16.6041H14.9029V18.3221H12.4053ZM23.2218 18.3221H20.2868L19.9273 16.6041H22.5415L23.2315 18.3221H23.2218ZM24.456 21.4048H21.0935L20.6367 19.6868H23.7757L24.4657 21.4048H24.456Z"
        fill={strokeColor}
      />
      <path
        d="M7.41021 14.9842H8.99429C9.19838 14.9842 9.39274 14.8664 9.51908 14.67C9.62598 14.5031 9.68429 14.297 9.68429 14.081C9.68429 13.865 9.62598 13.649 9.51908 13.4821C9.39274 13.2858 9.19838 13.168 8.99429 13.168H7.41021C7.20613 13.168 7.01176 13.2858 6.88543 13.4821C6.77852 13.649 6.72021 13.8552 6.72021 14.0712C6.72021 14.2871 6.77852 14.5031 6.88543 14.67C7.01176 14.8664 7.20613 14.9842 7.41021 14.9842Z"
        fill={strokeColor}
      />
      <path
        d="M21.0254 14.081C21.0254 14.3068 21.0837 14.5129 21.1906 14.67C21.3169 14.8664 21.5113 14.9842 21.7154 14.9842H23.2995C23.5036 14.9842 23.6979 14.8664 23.8243 14.67C23.9312 14.5031 23.9895 14.297 23.9895 14.0712C23.9895 13.8454 23.9312 13.6392 23.8243 13.4821C23.6979 13.2858 23.5036 13.168 23.2995 13.168H21.7154C21.5113 13.168 21.3169 13.2858 21.1906 13.4821C21.0837 13.649 21.0254 13.8552 21.0254 14.081Z"
        fill={strokeColor}
      />
      <path
        d="M15.5637 8.68152C15.7775 8.68152 15.9719 8.60298 16.1274 8.4459C16.2828 8.29864 16.3606 8.09247 16.3703 7.87649V5.81485C16.3703 5.37307 16.0205 5.00001 15.5831 5.00001C15.3596 4.99019 15.1652 5.07855 15.0098 5.22581C14.8543 5.37307 14.7668 5.57923 14.7668 5.79521V7.84704C14.7571 8.28882 15.1167 8.66188 15.554 8.66188L15.5637 8.68152Z"
        fill={strokeColor}
      />
      <path
        d="M10.7333 11.0967C10.8791 11.244 11.0832 11.3323 11.2873 11.3323C11.3359 11.3323 11.3845 11.3127 11.4428 11.3029C10.7333 12.1177 10.296 13.1485 10.296 14.2874C10.296 14.6801 10.6264 14.9942 11.0249 14.9942C11.4233 14.9942 11.7538 14.6801 11.7538 14.2874C11.7538 12.4319 13.367 10.9298 15.3592 10.9298C17.3515 10.9298 18.9647 12.4319 18.9647 14.2874C18.9647 14.6801 19.2951 14.9942 19.6936 14.9942C20.092 14.9942 20.4225 14.6801 20.4225 14.2874C20.4225 13.1485 19.9851 12.1275 19.2757 11.3029C19.3243 11.3127 19.3729 11.3323 19.4312 11.3323C19.645 11.3323 19.8394 11.244 19.9851 11.0967L21.3846 9.67321C21.6858 9.35905 21.6858 8.85837 21.3846 8.54421L21.3651 8.52458C21.2194 8.38713 21.025 8.30859 20.8306 8.30859C20.6363 8.30859 20.4613 8.37732 20.3156 8.50494L18.8675 9.97754C18.6732 10.1837 18.6149 10.4684 18.6732 10.7237C17.7791 9.98736 16.6323 9.52595 15.3592 9.52595C14.0861 9.52595 12.9394 9.98736 12.0453 10.7138C12.1036 10.4488 12.0453 10.1739 11.8509 9.96773L10.4515 8.54421C10.3057 8.39695 10.1017 8.30859 9.89757 8.30859C9.68377 8.30859 9.4894 8.39695 9.34363 8.54421C9.04236 8.85837 9.04236 9.35905 9.34363 9.67321L10.7431 11.0967H10.7333Z"
        fill={strokeColor}
      />
    </g>
    <defs>
      <clipPath id="clip0_2661_7718">
        <rect width="21.1858" height="21.1858" fill="white" transform="translate(5 5)" />
      </clipPath>
    </defs>
  </svg>
);

export const MultisiteTableIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="-4 -4 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <mask
      id="mask0_3631_12714"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3631_12714)">
      <path
        d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 8.325H19V5H5V8.325ZM5 13.675H19V10.325H5V13.675ZM5 19H19V15.675H5V19ZM6 7.65V5.65H8V7.65H6ZM6 13V11H8V13H6ZM6 18.35V16.35H8V18.35H6Z"
        fill={strokeColor}
      />
    </g>
  </svg>
);

export const TrendsIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M12.1556 18.9472L15.0361 16.0667L16.925 17.9556L20.5139 14.3903V16.2083H21.9306V11.9583H17.6806V13.375H19.4986L16.925 15.9486L15.0361 14.0597L11.1639 17.9556L12.1556 18.9472ZM9.41667 24C9.03889 24 8.70833 23.8583 8.425 23.575C8.14167 23.2917 8 22.9611 8 22.5833V8.41667C8 8.03889 8.14167 7.70833 8.425 7.425C8.70833 7.14167 9.03889 7 9.41667 7H23.5833C23.9611 7 24.2917 7.14167 24.575 7.425C24.8583 7.70833 25 8.03889 25 8.41667V22.5833C25 22.9611 24.8583 23.2917 24.575 23.575C24.2917 23.8583 23.9611 24 23.5833 24H9.41667ZM9.41667 22.5833H23.5833V8.41667H9.41667V22.5833Z"
      fill={strokeColor}
    />
  </svg>
);

export const SprinklersIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <g clipPath="url(#clip0_2046_3477)">
      <path
        d="M20.9913 8H10.0677C9.73191 8 9.45996 8.28673 9.45996 8.64082V9.16785C9.45996 9.52194 9.73191 9.80867 10.0677 9.80867H11.7262V10.7144C11.7262 10.7335 11.727 10.7526 11.7288 10.7717C11.7124 10.9528 11.7702 11.1395 11.9014 11.2787L12.5912 12.006C12.8252 12.2527 13.2042 12.2527 13.4381 12.006C13.6721 11.7593 13.6721 11.3597 13.4381 11.1131L12.9236 10.5705V9.80867H14.9144V13.2503H13.7722C13.407 13.2503 12.6698 14.0259 12.6698 14.4109C12.6698 14.7959 13.407 14.6821 13.7722 14.6821H17.1953C17.5605 14.6821 18.2977 14.7968 18.2977 14.4109C18.2977 14.0249 17.5605 13.2503 17.1953 13.2503H16.1127V9.80958H18.1035V10.4859L17.5078 11.114C17.2738 11.3606 17.2738 11.7602 17.5078 12.0069C17.7418 12.2536 18.1207 12.2536 18.3547 12.0069L19.0445 11.2796C19.0833 11.2387 19.1162 11.1922 19.142 11.144C19.2405 11.0311 19.3018 10.8809 19.3018 10.7162V9.81049H20.9921C21.328 9.81049 21.5999 9.52376 21.5999 9.16967V8.64264C21.5999 8.28855 21.328 8.00182 20.9921 8.00182L20.9913 8Z"
        fill={strokeColor}
      />
      <path
        d="M13.2565 16.2258C13.2565 16.2258 10.3264 16.8057 11.5247 18.1201C12.5529 19.2479 13.2565 16.2258 13.2565 16.2258Z"
        fill={strokeColor}
      />
      <path
        d="M17.7485 16.1167C17.7485 16.1167 17.9514 19.2525 19.3293 18.1529C20.5129 17.209 17.7485 16.1167 17.7485 16.1167Z"
        fill={strokeColor}
      />
      <path
        d="M18.3433 19.9717C18.3433 19.9717 17.562 23.0046 19.2057 22.4412C20.6173 21.9569 18.3433 19.9717 18.3433 19.9717Z"
        fill={strokeColor}
      />
      <path
        d="M20.8506 19.1042C20.8506 19.1042 21.8339 22.0717 22.8863 20.6262C23.7902 19.3855 20.8506 19.1042 20.8506 19.1042Z"
        fill={strokeColor}
      />
      <path
        d="M12.5555 20.0645C12.5555 20.0645 10.1736 21.9541 11.7992 22.5722C13.1952 23.1029 12.5555 20.0645 12.5555 20.0645Z"
        fill={strokeColor}
      />
      <path
        d="M15.3415 16.4133C15.3415 16.4133 13.7573 19.0758 15.4856 19.0403C16.9697 19.0094 15.3415 16.4133 15.3415 16.4133Z"
        fill={strokeColor}
      />
      <path
        d="M15.3415 20.373C15.3415 20.373 13.7573 23.0355 15.4856 23C16.9697 22.9691 15.3415 20.373 15.3415 20.373Z"
        fill={strokeColor}
      />
      <path
        d="M10.0202 19.0596C10.0202 19.0596 7.09008 19.6394 8.28836 20.9538C9.31657 22.0816 10.0202 19.0596 10.0202 19.0596Z"
        fill={strokeColor}
      />
    </g>
    <defs>
      <clipPath id="clip0_2046_3477">
        <rect width="15.0588" height="15" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const ConfigurationIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path
        clipRule="evenodd"
        d="M14 20C17.3137 20 20 17.3137 20 14C20 10.6863 17.3137 8 14 8C10.6863 8 8 10.6863 8 14C8 17.3137 10.6863 20 14 20ZM18 14C18 16.2091 16.2091 18 14 18C11.7909 18 10 16.2091 10 14C10 11.7909 11.7909 10 14 10C16.2091 10 18 11.7909 18 14Z"
        fill="#ffffff"
        fillRule="evenodd"
      ></path>
      <path
        clipRule="evenodd"
        d="M0 12.9996V14.9996C0 16.5478 1.17261 17.822 2.67809 17.9826C2.80588 18.3459 2.95062 18.7011 3.11133 19.0473C2.12484 20.226 2.18536 21.984 3.29291 23.0916L4.70712 24.5058C5.78946 25.5881 7.49305 25.6706 8.67003 24.7531C9.1044 24.9688 9.55383 25.159 10.0163 25.3218C10.1769 26.8273 11.4511 28 12.9993 28H14.9993C16.5471 28 17.8211 26.8279 17.9821 25.3228C18.4024 25.175 18.8119 25.0046 19.2091 24.8129C20.3823 25.6664 22.0344 25.564 23.0926 24.5058L24.5068 23.0916C25.565 22.0334 25.6674 20.3813 24.814 19.2081C25.0054 18.8113 25.1757 18.4023 25.3234 17.9824C26.8282 17.8211 28 16.5472 28 14.9996V12.9996C28 11.452 26.8282 10.1782 25.3234 10.0169C25.1605 9.55375 24.9701 9.10374 24.7541 8.66883C25.6708 7.49189 25.5882 5.78888 24.5061 4.70681L23.0919 3.29259C21.9846 2.18531 20.2271 2.12455 19.0485 3.1103C18.7017 2.94935 18.3459 2.80441 17.982 2.67647C17.8207 1.17177 16.5468 0 14.9993 0H12.9993C11.4514 0 10.1773 1.17231 10.0164 2.6775C9.60779 2.8213 9.20936 2.98653 8.82251 3.17181C7.64444 2.12251 5.83764 2.16276 4.70782 3.29259L3.2936 4.7068C2.16377 5.83664 2.12352 7.64345 3.17285 8.82152C2.98737 9.20877 2.82199 9.60763 2.67809 10.0167C1.17261 10.1773 0 11.4515 0 12.9996ZM15.9993 3C15.9993 2.44772 15.5516 2 14.9993 2H12.9993C12.447 2 11.9993 2.44772 11.9993 3V3.38269C11.9993 3.85823 11.6626 4.26276 11.2059 4.39542C10.4966 4.60148 9.81974 4.88401 9.18495 5.23348C8.76836 5.46282 8.24425 5.41481 7.90799 5.07855L7.53624 4.70681C7.14572 4.31628 6.51256 4.31628 6.12203 4.7068L4.70782 6.12102C4.31729 6.51154 4.31729 7.14471 4.70782 7.53523L5.07958 7.90699C5.41584 8.24325 5.46385 8.76736 5.23451 9.18395C4.88485 9.8191 4.6022 10.4963 4.39611 11.2061C4.2635 11.6629 3.85894 11.9996 3.38334 11.9996H3C2.44772 11.9996 2 12.4474 2 12.9996V14.9996C2 15.5519 2.44772 15.9996 3 15.9996H3.38334C3.85894 15.9996 4.26349 16.3364 4.39611 16.7931C4.58954 17.4594 4.85042 18.0969 5.17085 18.6979C5.39202 19.1127 5.34095 19.6293 5.00855 19.9617L4.70712 20.2632C4.3166 20.6537 4.3166 21.2868 4.70712 21.6774L6.12134 23.0916C6.51186 23.4821 7.14503 23.4821 7.53555 23.0916L7.77887 22.8483C8.11899 22.5081 8.65055 22.4633 9.06879 22.7008C9.73695 23.0804 10.4531 23.3852 11.2059 23.6039C11.6626 23.7365 11.9993 24.1411 11.9993 24.6166V25C11.9993 25.5523 12.447 26 12.9993 26H14.9993C15.5516 26 15.9993 25.5523 15.9993 25V24.6174C15.9993 24.1418 16.3361 23.7372 16.7929 23.6046C17.5032 23.3985 18.1809 23.1157 18.8164 22.7658C19.233 22.5365 19.7571 22.5845 20.0934 22.9208L20.2642 23.0916C20.6547 23.4821 21.2879 23.4821 21.6784 23.0916L23.0926 21.6774C23.4831 21.2868 23.4831 20.6537 23.0926 20.2632L22.9218 20.0924C22.5855 19.7561 22.5375 19.232 22.7669 18.8154C23.1166 18.1802 23.3992 17.503 23.6053 16.7931C23.7379 16.3364 24.1425 15.9996 24.6181 15.9996H25C25.5523 15.9996 26 15.5519 26 14.9996V12.9996C26 12.4474 25.5523 11.9996 25 11.9996H24.6181C24.1425 11.9996 23.7379 11.6629 23.6053 11.2061C23.3866 10.4529 23.0817 9.73627 22.7019 9.06773C22.4643 8.64949 22.5092 8.11793 22.8493 7.77781L23.0919 7.53523C23.4824 7.14471 23.4824 6.51154 23.0919 6.12102L21.6777 4.7068C21.2872 4.31628 20.654 4.31628 20.2635 4.7068L19.9628 5.00748C19.6304 5.33988 19.1137 5.39096 18.6989 5.16979C18.0976 4.84915 17.4596 4.58815 16.7929 4.39467C16.3361 4.2621 15.9993 3.85752 15.9993 3.38187V3Z"
        fill="#ffffff"
        fillRule="evenodd"
      ></path>
    </g>
  </svg>
);

export const AgriIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M15.875 23V16.4718H15.4583C14.5694 16.4718 13.7326 16.2993 12.9479 15.9542C12.1632 15.6092 11.4653 15.1197 10.8542 14.4859C10.2431 13.8521 9.78125 13.1197 9.46875 12.2887C9.15625 11.4577 9 10.5915 9 9.69014V8H10.6317C11.4883 8 12.3125 8.17254 13.1042 8.51761C13.8958 8.86268 14.6042 9.35211 15.2292 9.98592C15.6875 10.4648 16.066 11 16.3646 11.5915C16.6632 12.1831 16.875 12.8099 17 13.4718C17.1062 13.3042 17.223 13.1426 17.3505 12.987C17.4779 12.8313 17.6111 12.6761 17.75 12.5211C18.375 11.8873 19.0833 11.3979 19.875 11.0528C20.6667 10.7077 21.4977 10.5352 22.3681 10.5352H24V12.2254C24 13.1268 23.8335 13.993 23.5004 14.8239C23.1674 15.6549 22.695 16.3873 22.0833 17.0211C21.4583 17.6549 20.753 18.1408 19.9675 18.4789C19.1819 18.8169 18.3594 18.9859 17.5 18.9859H17.125V23H15.875ZM15.8958 15.1831C15.8958 14.3239 15.7569 13.5246 15.4792 12.7852C15.2014 12.0458 14.8194 11.419 14.3333 10.9049C13.8472 10.3908 13.25 9.98944 12.5417 9.7007C11.8333 9.41197 11.0694 9.26761 10.25 9.26761C10.25 10.1549 10.3785 10.9683 10.6354 11.7077C10.8924 12.4472 11.2639 13.0775 11.75 13.5986C12.3333 14.2324 12.9618 14.6549 13.6354 14.8662C14.309 15.0775 15.0625 15.1831 15.8958 15.1831ZM17.125 17.7183C17.9583 17.7183 18.7292 17.581 19.4375 17.3063C20.1458 17.0317 20.7431 16.6373 21.2292 16.1232C21.7153 15.6092 22.0903 14.9824 22.3542 14.243C22.6181 13.5035 22.75 12.6901 22.75 11.8028C21.9167 11.8028 21.1458 11.9472 20.4375 12.2359C19.7292 12.5246 19.1319 12.9225 18.6458 13.4296C18.0486 14.0634 17.6458 14.7254 17.4375 15.4155C17.2292 16.1056 17.125 16.8732 17.125 17.7183Z"
      fill={strokeColor}
    />
  </svg>
);

export const CamerasIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 -4 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M18.2555 15.625L15.9899 14.3229L19.6357 11.6146L21.8753 12.9166L18.2555 15.625ZM13.3337 12.4479L16.042 10.3906L8.85449 6.24997L7.29199 8.95831L13.3337 12.4479ZM4.16699 20.8333V18.75H9.37533L9.37533 12.5521L6.25033 10.7552C5.74685 10.46 5.42133 10.039 5.27376 9.49216C5.12619 8.94529 5.19998 8.42011 5.49512 7.91664L7.05762 5.20831C7.35276 4.70483 7.77376 4.37931 8.32064 4.23174C8.86751 4.08417 9.39269 4.15796 9.89616 4.4531L19.818 10.1823L13.4639 14.9218L11.4587 13.776L11.4587 18.75C11.4587 19.3229 11.2547 19.8133 10.8467 20.2213C10.4387 20.6293 9.94824 20.8333 9.37533 20.8333H4.16699Z"
      fill={strokeColor}
    />
  </svg>
);

export const DeploymentsIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path
      d="M25.7 5.3C25.7 5.3 20.4 4.6 16.5 8.5C14.5 10.5 13.1 13.1 12.2 15.1L8.7 14.6L5 18.3L10.1 20.2L7.6 22.7L8 25.5L10.8 25.9L13.3 23.4L15.2 28.5L18.9 24.8L18.4 21.3C20.4 20.4 23 19 25 17C28.9 13.1 28.2 7.8 28.2 7.8L25.7 5.3ZM23.6 15.6C22 17.2 19.8 18.4 18 19.2L17.4 19.5L17.7 22.1L16 23.8L14.5 19.9L13.6 19L9.7 17.5L11.4 15.8L14 16.1L14.3 15.5C15.1 13.7 16.3 11.5 17.9 9.9C20.6 7.2 24.2 7 25.3 7L26.5 8.2C26.5 9.3 26.3 12.9 23.6 15.6Z"
      fill={strokeColor}
    />
    <circle cx="21" cy="12.5" r="1.8" fill={strokeColor} />
  </svg>
);

export const ReportsIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    width="32"
    height="32"
    {...restProps}
  >
    <g
      transform="translate(3.75 3.75) scale(0.60)"
      stroke={strokeColor}
      fill={strokeColor}
      strokeWidth="0.8"
    >
      <path
        d="M18.015 4.829c6.809 0.21 12.237 5.798 12.237 12.628 0 6.978 -5.657 12.634 -12.634 12.634 -6.835 0 -12.426 -5.437 -12.629 -12.252 -0.011 -0.353 -0.305 -0.631 -0.659 -0.621s-0.631 0.305 -0.621 0.659c0.223 7.506 6.38 13.494 13.909 13.494 7.685 0 13.914 -6.23 13.914 -13.914 0 -7.522 -5.978 -13.676 -13.478 -13.908 -0.353 -0.011 -0.649 0.267 -0.659 0.62s0.267 0.649 0.62 0.659z"
        fill={strokeColor}
      />
      <path
        d="M1.615 14.563h12.948V1.615C7.559 1.939 1.939 7.559 1.615 14.563m-1.295 0.64c0 -8.22 6.663 -14.883 14.883 -14.883 0.353 0 0.64 0.287 0.64 0.64v14.243c0 0.353 -0.287 0.64 -0.64 0.64H0.96c-0.353 0 -0.64 -0.287 -0.64 -0.64"
        fill={strokeColor}
      />
      <path
        d="M17.236 4.204v12.675c0 0.175 -0.145 0.32 -0.32 0.32H4.38c-0.353 0 -0.64 0.287 -0.64 0.64s0.287 0.64 0.64 0.64h12.536c0.881 0 1.6 -0.719 1.6 -1.6V4.204c0 -0.353 -0.287 -0.64 -0.64 -0.64s-0.64 0.287 -0.64 0.64"
        fill={strokeColor}
      />
    </g>
  </svg>
);

export const InvertersIcon = ({ backgroundColor, strokeColor, ...restProps }: INavIconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...restProps}>
        <rect x="8" y="6" width="16" height="20" rx="2" stroke={strokeColor} strokeWidth="1.8" />
        <path d="M17.25 10L13.5 16H16.5L14.75 22L20 14.75H17.25V10Z" fill={strokeColor} />
        <path d="M12 28H20" stroke={strokeColor} strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
